import { Pipe, PipeTransform } from '@angular/core';
import { ConvertToDateTimeAu } from "../utils/datetime.helper";

@Pipe({
  name: 'auTime',
  standalone: true
})
export class AuTimePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): Date | null {
    return AuTimePipe.formatValue(value);
  }

  static formatValue(value: string | Date | null | undefined): Date | null {
    if (!value || value == 'Invalid Date') return null;

    let date: Date;

    if (typeof value === 'string') {
      const parsed = Date.parse(value);
      if (isNaN(parsed)) return null;
      date = new Date(parsed);
    } else if (value instanceof Date) {
      date = value;
    } else {
      return null;
    }

    return ConvertToDateTimeAu(date);
  }
}
